export const itemDetailPageStyle = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 'calc(100vh - 128px)',
    '@media (max-width: 1199.98px)': {
      minHeight: 'calc(100vh - 152px)',
    },

    '@media (max-width: 639.98px)': {
      // minHeight: 'auto',
      padding: '0 4px 16px',
    },
  },

  wrapperContent: {
    background: 'var(--default-white)',
    borderRadius: '8px',
    boxShadow: 'var(--box-shadow--2)',
    padding: '24px',
    position: 'relative',
    height: 'auto',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '16px',

    '@media (max-width: 639.98px)': {
      padding: '20px 16px',
      marginTop: '12px',
    },
  },

  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    width: '100%',
  },

  wrapperHeader: {
    background: 'var(--default-white)',
    borderRadius: '8px',
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: 'var(--box-shadow--2)',
    alignContent: 'center',

    '@media (max-width: 639.98px)': {
      display: 'none',
    },
  },

  content: {
    maxWidth: '432px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    position: 'relative',

    '@media (min-width: 1200px)': {
      width: '432px',
    },

    '@media (max-width: 1199.98px)': {
      maxWidth: '523px',
    },

    '@media (max-width: 899.98px)': {
      maxWidth: '100%',
    },

    '@media (max-width: 639.98px)': {
      maxWidth: '100%',
    },
  },

  logosWrapper: {
    display: 'flex',
    gap: '24px',
    marginBottom: '24px',

    '@media (max-width: 1199.98px)': {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      alignItems: 'flex-start',
    },

    '@media (max-width: 899.98px)': {
      gridTemplateColumns: '1fr',
      rowGap: '20px',
    },

    '@media (max-width: 639.98px)': {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
  },

  donorLogo: {
    maxWidth: '523px',
    overflow: 'hidden',
    height: '260px',
    width: '100%',

    '@media (min-width: 1200px)': {
      width: '432px',
    },

    '@media (max-width: 1199.98px)': {
      height: '280px',
    },

    '@media (max-width: 899.98px)': {
      height: '300px',
      maxWidth: '100%',
    },

    '@media (max-width: 639.98px)': {
      height: '224px',
    },

    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
      display: 'block',
    },

    '&:not(:first-of-type)': {
      maxWidth: '80px',
      height: '80px',
      borderRadius: '4px',
      overflow: 'hidden',

      '@media (max-width: 1199.98px)': {
        width: 'calc((100% - 32px) / 5)',
        height: 'auto',
        aspectRatio: '1 / 1',
        maxWidth: 'none',
      },

      // '@media (max-width: 599.98px)': {
      // 	width: 'calc((100% - 24px) / 4)',
      // },
    },
  },

  title: {
    marginBottom: '16px',

    '@media (max-width: 639.98px)': {
      marginBottom: '12px',
    },
  },

  category: {
    color: 'var(--neutral-300)',
  },

  valuesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '20px',

    '@media (max-width: 639.98px)': {
      marginBottom: '16px',
      gap: '6px',
    },
  },

  valuesTitles: {
    display: 'flex',
    '& p': {fontWeight: 400},
  },

  valuesTitle: {
    marginRight: '4px',
    color: 'var(--neutral-300)',
  },

  winnerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  description: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '24px',

    '@media (max-width: 639.98px)': {
      marginBottom: '20px',
    },
  },

  icon: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',

    svg: {
      path: {
        fill: 'var(--primary-500)',
      },
    },
  },

  iconDisable: {
    svg: {
      path: {
        fill: 'var(--primary-200) !important',
      },
    },
  },

  iconRight: {
    display: 'flex',
    alignContent: 'flex-end',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',

    svg: {
      path: {
        fill: 'var(--primary-500)',
      },
    },
  },

  button: {
    display: 'flex',
    gap: '8px',
    alignContent: 'center',
    justifyContent: 'center',
    padding: '4px',

    '@media (max-width: 639.98px)': {
      fontSize: '14px',
    },
  },

  donorImage: {
    width: '134px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '8px',
    border: '1px solid var(--neutral-50)',
    boxShadow: 'var(--box-shadow--1)',
    height: '100%',

    '& img': {
      objectFit: 'cover',
      height: '104px',
      width: '100%',
      display: 'block',
    },
  },

  donorImages: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    marginTop: '12px',
    alignItems: 'stretch',

    '@media (max-width: 639.98px)': {
      gap: '16px',
    },
  },

  donorName: {
    background: 'var(--default-white)',
    padding: '10px 12px',
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '1.2',
    maxHeight: '46px',

    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    wordBreak: 'break-word',

    flexGrow: 1,
    borderTop: '1px solid var(--neutral-50)',
  },

  bidWrapper: {
    display: 'flex',
    gap: '24px',
    marginBottom: '12px',

    // '@media (max-width: 639.98px)': {
    // 	flexDirection: 'column',
    // 	gap: '12px',
    // },
  },

  bid: {
    display: 'flex',
    flexDirection: 'column',
    color: 'var(--neutral-300)',

    '&:first-child': {
      paddingRight: '50px',
      borderRight: '1px solid var(--neutral-100)',
    },
  },

  modalBid: {
    '.MuiPaper-root': {
      maxWidth: '972px',
      padding: '48px 200px',
      width: '100%',

      '@media (max-width: 1199.98px)': {
        padding: '48px 80px',
      },

      '@media (max-width: 639.98px)': {
        padding: '40px 20px',
      },

      '.MuiBox-root': {
        width: '100%',
      },
    },
  },

  altContent: {
    position: 'relative',
    width: '100%',
    height: '260px',
    borderRadius: '12px',
    overflow: 'hidden',
    background: 'var(--neutral-50)',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& img': {
      width: '70%',
      maxWidth: '320px',
      objectFit: 'contain',
    },
  },

  buttonWrapper: {
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',
  },

  drawer: {
    '@media (min-width: 640px)': {
      display: 'none',
    },
  },
  popup: {
    display: 'flex',
    gap: '32px',
    padding: '24px',
    height: '100%',
    justifyContent: 'center',

    '@media (min-width: 640px)': {display: 'none'},
  },
};
